import cx from 'clsx';
import React from 'react';

import Select from '@components/uikit/Select/Select';

import { getAIStatusesList } from '@helpers/getAIStatusesList';
import { getAITypesList } from '@helpers/getAITypesList';
import { getAIUrgenciesList } from '@helpers/getAIUrgenciesList';

import useTranslation from '@hooks/useTranslation';

import {
  selectAIStatus,
  selectAIType,
  selectAIUrgency,
  useActionItemsStorePersistAction,
} from '../../store/useActionItemsStorePersist';
import style from './style.module.scss';

const ActionItemsFilter = () => {
  const { setAIType, setAIUrgencyType, setAIStatusType } = useActionItemsStorePersistAction();
  const { t } = useTranslation();

  const typeStore = selectAIType();
  const urgencyType = selectAIUrgency();
  const statusType = selectAIStatus();

  const urgenciesList = getAIUrgenciesList(t);
  const typesList = getAITypesList(t);
  const statusesList = getAIStatusesList(t);

  return (
    <div id="tourStep-9" className={style.actionItemsSelectsWrapper}>
      <div className={style.actionItemsSelectWrapper}>
        <Select
          value={urgencyType.value === 'all' ? urgenciesList[0] : urgencyType}
          onChange={(option) => setAIUrgencyType(option)}
          options={urgenciesList}
          label={t('Urgency')}
          itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'label' }}
          type={'woHelperText'}
          dataQa={'urgency-filter'}
        />
      </div>
      <div className={cx(style.actionItemsSelectWrapper, style.hideOnSmallDevice)}>
        <Select
          value={typeStore.value === 'all' ? typesList[0] : typeStore}
          onChange={(option) => setAIType(option)}
          options={typesList}
          label={t('Action Item Type')}
          itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'label' }}
          type={'woHelperText'}
          dataQa={'type-filter'}
        />
      </div>
      <div className={cx(style.actionItemsSelectWrapper, style.hideOnSmallDevice)}>
        <Select
          value={statusType.value === 'all' ? statusesList[0] : statusType}
          onChange={(option) => setAIStatusType(option)}
          options={statusesList}
          label={t('Status')}
          itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'label' }}
          type={'woHelperText'}
          dataQa={'status-filter'}
        />
      </div>
    </div>
  );
};

export default ActionItemsFilter;
